import { GzHealthDashboardLicensesWebComponent } from './component/GzHealthDashboardLicensesWebComponent';

export { GzHealthDashboardLicensesWebComponent };
